import styles from './styles.module.css';
import { DiagramDataItem } from '../../../../types/deal-taxes';
import { createPortal } from 'react-dom';
import DealTaxesAsideMenu from '../DealTaxesAsideMenu';
import React from 'react';

interface DealTaxesInfoProps {
    data: DiagramDataItem | undefined;
    initialInvestment?: number;
    returnOnAsset?: number;
    distribution?: number;
    inAside?: boolean;
}

const DealTaxesInfo = ({
    data,
    initialInvestment,
    returnOnAsset,
    distribution,
    inAside = false,
}: DealTaxesInfoProps) => {
    return (
        <div className={`${styles.info} ${inAside ? styles.visible : ''}`}>
            {document.querySelector('#asideTitle') &&
                createPortal(
                    <h3 className={styles.title}>
                        <span>
                            This <span className={'highlight-secondary'}>tax review</span> for:
                        </span>
                    </h3>,
                    document.querySelector('#asideTitle')!,
                )}

            <h5 className={styles.subTitle}>
                <span>Initial investment: </span>
                <span>${initialInvestment || 100}</span>
            </h5>
            <h5>
                <span>Return on asset: </span>
                <span>{returnOnAsset || 20}%</span>
            </h5>
            <h5>
                <span>Distribution: </span>
                <span>${distribution || 10}</span>
            </h5>
            <h5>
                <span>Return on investment</span>

                <span>{((data?.returnOnInvestment || 1) * 100).toFixed(2)}%</span>
            </h5>
            {/*</div>*/}
        </div>
    );
};

export default DealTaxesInfo;
